import { UserInterface, UserVarKey, UserVarsMap } from "@swivl-mono/types";
import { Button, ButtonVariant } from "@swivl-mono/ui";
import { useEffect, useMemo, useState } from "react";

import { filterClasses } from "@swivl-mono/helpers";
import { UserDetailsUserVarsComponent } from "../Components/UserDetails.UserVars";
import { UserDetailsEditBasicInfoView } from "../Components/UserDetails.EditBasicInfo";

interface EditCustomerDetailsProps {
  isPanelOpen: boolean;
  user: UserInterface;
  userVars: UserVarsMap | undefined;
}

const topLevelKeys = [
  "name",
  "phoneNumber",
  "email",
  "locationId",
  "postalCode",
  // "FilterSize",
  // "FilterFeatures",
  // "Location",
  // "EmailType",
];

export type TopLevelKey = (typeof topLevelKeys)[number];

export default function UserDetailsEditCustomerDetailsView({ isPanelOpen, user, userVars }: EditCustomerDetailsProps) {
  const [isShowingOtherVars, setIsShowingOtherVars] = useState(false);
  const { topLevelVars, otherVars } = useMemo(() => {
    const topLevelVars: UserVarsMap = {};
    const otherVars: UserVarsMap = {};

    if (userVars) {
      for (const [userVarKey, value] of Object.entries(userVars)) {
        if (topLevelKeys.includes(userVarKey as TopLevelKey)) {
          topLevelVars[userVarKey as TopLevelKey] = value;
        } else {
          otherVars[userVarKey as TopLevelKey] = value;
        }
      }
    }

    if (user) {
      for (const [userKey, value] of Object.entries(user)) {
        if (topLevelKeys.includes(userKey as TopLevelKey)) {
          topLevelVars[userKey as TopLevelKey] = value;
        } else {
          otherVars[userKey as TopLevelKey] = value;
        }
      }
    }

    return { topLevelVars, otherVars };
  }, [userVars]);

  useEffect(() => {
    if (!isPanelOpen) {
      setIsShowingOtherVars(false);
    }
  }, [isPanelOpen]);

  const showText = isShowingOtherVars ? "Hide Other Variables" : "Show Other Variables";

  const handleSetIsShowingOtherVars = () => {
    setIsShowingOtherVars(!isShowingOtherVars);
  };

  return (
    <div key={"edit" + user.id}>
      <UserDetailsEditBasicInfoView user={user} />
      {/* <UserDetailsUserVarsComponent user={user} userVars={topLevelVars} /> */}
      <div className="my-2">
        <Button variant={ButtonVariant.GHOST} onClick={handleSetIsShowingOtherVars}>{showText}</Button>
      </div>
      <div className={filterClasses("transition-opacity duration-300 ease-in-out", isShowingOtherVars ? "opacity-100" : "opacity-0")}>
        <UserDetailsUserVarsComponent user={user} userVars={otherVars} />
      </div>
    </div>
  );
}
